import { render, staticRenderFns } from "./ShareEarnModal.vue?vue&type=template&id=5ed7b906&scoped=true"
import script from "./ShareEarnModal.vue?vue&type=script&lang=js"
export * from "./ShareEarnModal.vue?vue&type=script&lang=js"
import style0 from "./ShareEarnModal.vue?vue&type=style&index=0&id=5ed7b906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed7b906",
  null
  
)

export default component.exports